import axios from 'axios';
export default (name, callback) => {
    axios.get(`/api/guild/${name}`)
        .then(response => {
            callback(null, response.data);
        })
        .catch(e => {
            callback(e, null);
        })
};